import { Coffee } from 'lucide-react';
import { useVenue } from '@core/contexts/VenueContext';
import { brandLogoUrl } from '@core/hooks/useBranding';
import { BrandLogo } from '@core/components/BrandLogo';

interface WelcomeScreenProps {
  onStart: () => void;
}

export function WelcomeScreen({ onStart }: WelcomeScreenProps) {
  const { venue } = useVenue();

  const venueName = venue?.name || 'нашего клуба';
  const logoUrl = brandLogoUrl(venue?.branding);

  return (
    <div className="min-h-screen bg-gradient-dark flex flex-col items-center justify-center p-8 text-center">
      <div className="bg-gradient-neon rounded-3xl w-40 h-40 flex items-center justify-center mb-8 shadow-neon-lg">
        <BrandLogo
          src={logoUrl}
          alt={venue?.name ?? ''}
          className="w-32 h-32 rounded-3xl"
          fallback={<Coffee size={80} className="text-black" strokeWidth={1.5} />}
        />
      </div>

      <h1 className="text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-success">
        Добро пожаловать в {venueName}!
      </h1>

      <p className="text-text-muted text-lg mb-8 max-w-sm">
        Станьте частью нашего клуба, получайте баллы за каждую покупку и обменивайте их на подарки.
      </p>

      <button
        onClick={onStart}
        className="bg-gradient-neon text-black font-bold px-8 py-4 rounded-xl shadow-neon hover:shadow-neon-lg active:scale-95 transition-all w-full max-w-sm"
      >
        Начать и получить бонус!
      </button>
    </div>
  );
}


